import { HTMLAttributes } from "react";

interface ScheduleGeneratorIconProps extends HTMLAttributes<SVGElement> {}

const ScheduleGeneratorIcon = ({ ...props }: ScheduleGeneratorIconProps) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 19H22C23.1046 19 24 18.1046 24 17V5C24 3.89543 23.1046 3 22 3H4C2.89543 3 2 3.89543 2 5V10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1L7.5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.5 1L18.5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11.1254 19.9354L12.178 23.055C12.2111 23.1323 12.2642 23.1997 12.3317 23.2503C12.3993 23.3009 12.479 23.3329 12.5627 23.343C12.6228 23.3501 12.6837 23.3458 12.742 23.3302C12.8458 23.3022 12.9368 23.24 13.0003 23.1537L14.8043 20.7059C14.8469 20.6487 14.8761 20.5827 14.8895 20.5125C14.9029 20.4424 14.9003 20.3701 14.8818 20.3009L13.9314 16.8096L15.2018 14.6159C15.5466 14.0225 15.7693 13.3661 15.8568 12.6845C15.9444 12.003 15.8951 11.31 15.7119 10.6458L15.479 9.79019C15.4126 9.54619 14.9223 8.10838 14.7025 7.98144C14.4826 7.8545 12.9923 8.14883 12.7478 8.21331L11.8904 8.4394C11.2235 8.61285 10.5987 8.91669 10.0523 9.33328C9.50586 9.74988 9.04866 10.2709 8.70718 10.8663L7.44263 13.0633L3.94384 13.9859C3.87445 14.0051 3.81045 14.0398 3.75664 14.0873C3.70282 14.1348 3.66059 14.1939 3.63311 14.2601L2.4153 17.0463C2.38117 17.1235 2.36837 17.2085 2.37823 17.2925C2.38809 17.3766 2.42024 17.4567 2.47137 17.5245C2.52199 17.592 2.58952 17.645 2.66712 17.6782C2.74471 17.7114 2.8296 17.7237 2.91318 17.7137L6.26522 17.3228M9.44291 17.3787L5.20077 25.05M4.27004 20.9439L3.44738 22.2182"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ScheduleGeneratorIcon;
